<template>

    <VueDatePicker
        v-model="localValue"
        model-type="dd/MM/yyyy"
        format="dd/MM/yyyy"
        auto-apply
        text-input
        :placeholder="placeholder"
    />

</template>

<script>

    import { VueDatePicker } from '@vuepic/vue-datepicker'

    export default {

        name: 'DatePicker',

        components: { VueDatePicker },

        props: {
            placeholder: {
                type: String,
                default: ''
            }
        },

        emits: ['update:modelValue'],

        computed: {
            localValue: {
                get() {
                    return this.$attrs.modelValue;
                },
                set(val) {
                    this.$emit('update:modelValue', val);
                }
            }
        }

    }

</script>
